import { flexRender } from '@tanstack/react-table';
import type { ReactElement } from 'react';
import { EmptyContent } from '../EmptyContent';
import { MobileCardListSkeleton } from './MobileCardListSkeleton';
import { type MobileCardListProps } from './types';

export const MobileCardList = <T,>({
  rows,
  headerGroups,
  isLoading = false,
  columnsCount,
  emptyMessage = '',
  emptyTitle,
}: MobileCardListProps<T>): ReactElement => {
  const headers = headerGroups[0]?.headers ?? [];

  if (isLoading) {
    return <MobileCardListSkeleton columnsCount={columnsCount} rowsCount={rows?.length} />;
  }

  if (!rows?.length) {
    return (
      <div className="am-lg:hidden">
        <EmptyContent emptyTitle={emptyTitle} emptyMessage={emptyMessage} />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 am-lg:hidden">
      {rows.map(row => {
        const cells = row.getVisibleCells();
        return (
          <div key={row.id} className="rounded-md border shadow bg-white px-4 py-3">
            {cells.map((cell, i) => {
              const header = headers[i];
              const headerContent = header
                ? flexRender(header.column.columnDef.header, header.getContext())
                : null;
              return (
                <div
                  key={cell.id}
                  className="flex justify-between items-start gap-4 py-2 border-b last:border-0"
                >
                  {headerContent && (
                    <span className="text-sm font-medium text-gray-600 shrink-0">
                      {headerContent}
                    </span>
                  )}
                  <span className="text-sm text-right overflow-auto">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </span>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
